import { TypeSubscriberShopProduct } from '@/lib/api/productCatalog/types';

export const getUnpurchasableProducts = (
  products: TypeSubscriberShopProduct[],
): string[] => {
  return products
    .filter(
      ({ product }) => product.metadata.data?.replacement_shop_unpurchasable,
    )
    .map(({ product }) => product.name);
};

export const getUpdatedProducts = (
  products: TypeSubscriberShopProduct[],
): string[] => {
  return products
    .filter(
      ({ purchase_metadata }) =>
        purchase_metadata?.product_updated_since_purchase,
    )
    .map(({ product }) => product.name);
};
